type TAssistantParticipantStatusDto =
    | "needs_registration"
    | "no_next_session"
    | "sessions_to_schedule"
    | "all_scheduled"

enum EAssistantParticipantStatus {
    NoRegistration = "noRegistration",
    NoNextSession = "noNextSession",
    SessionsToSchedule = "sessionsToSchedule",
    AllScheduled = "allScheduled"
}

interface IAssistanceParticipantDto {
    id: number
    first_name: string
    last_name: string
    photo: string | null
    cohort_name: string
    has_coach: boolean
    has_unscheduled_sessions: boolean
    has_next_session: boolean
    unscheduled_sessions_count: number
    registration_deadline: string
    status: TAssistantParticipantStatusDto
}

interface IAssistanceParticipantModel {
    id: number
    firstName: string
    lastName: string
    photo: string | null
    unscheduledSessionsCount: number
    registrationDeadline: string
    status: EAssistantParticipantStatus
}

export { EAssistantParticipantStatus }
export type { TAssistantParticipantStatusDto, IAssistanceParticipantDto, IAssistanceParticipantModel }
